import { KeyValue } from '../models/common';

export function isNullUndefined<T>(
  value: T | null | undefined
): value is null | undefined {
  return value === null || value === undefined;
}

export const INITIAL_REDUCER_DATA = {
  data: null as KeyValue[] | null,
  errorMessages: null as string[] | null,
  isError: false,
  isLoading: false
};

export type IInitialReducerData = typeof INITIAL_REDUCER_DATA;
export type IReducerWithIsolated<T> = T & {
  isolated: IInitialReducerData;
};

export const haskeyReducer = (keyReducer: string | number) =>
  !isNullUndefined(keyReducer) && keyReducer && keyReducer !== 'default';

export const updateGetIsolated = (state: any, actionTypes: any) => ({
  ...state,
  isolated: {
    ...state.isolated,
    [actionTypes.payload.keyReducer]: {
      ...(state.isolated[actionTypes.payload.keyReducer] ??
        INITIAL_REDUCER_DATA),
      isLoading: true
    }
  }
});

export const updateSaveIsolated = (state: any, actionTypes: any) => ({
  ...state,
  isolated: {
    ...state.isolated,
    [actionTypes.payload.keyReducer]: {
      ...state.isolated[actionTypes.payload.keyReducer],
      isLoading: false,
      errorMessages: actionTypes.payload.errorMessages,
      isError: actionTypes.payload.isError,
      data: actionTypes.payload.data
    }
  }
});

export const resetIsolatedReducer = (state: any, actionTypes: any) => ({
  ...state,
  isolated: {
    ...state.isolated,
    [actionTypes.payload.keyReducer]: INITIAL_REDUCER_DATA
  }
});

interface IDefaultReducer {
  data: KeyValue[] | null;
  isLoading: boolean;
  isError: boolean;
  errorMessages: string[] | null;
}

export function isFinishedReducer(reducer: IDefaultReducer) {
  return (
    !reducer.isLoading &&
    (!isNullUndefined(reducer.data) ||
      !isNullUndefined(reducer.errorMessages) ||
      reducer.isError)
  );
}
